export const AppNotification = Object.freeze({
  DocumentEditActive: "document-edit-active",
  PoaEditActive: "poa-edit-active",
  ApproveInvalidDocument: "approve-invalid-document",
  FailedToProcessDocument: "failed-to-process-document",
  OfflineWorkerDetected: "offline-worker-detected",
  OfflineOnline: "offline-online",
  IdentificationTokenExpiring: "identification-token-expiring",
  UserSignedOut: "user-signed-out",
  SilentSignInFail: "silent-sign-in-fail",
  ScreeningLoadError: "screening-load-error",
  GetStatsError: "get-stats-error",
  WorkClosed: "work-closed",
  WorkStartError: "work-start-error",
  WaitForWorkError: "wait-for-work-error",
  GetIdentificationError: "get-identification-error",
  GetComplianceReviewListError: "get-compliance-review-list-error",
  GetComplianceReviewItemError: "get-compliance-review-item",
  ReprocessidentificationError: "reprocess-identification-error",
  DocumentSubmitError: "document-submit-error",
  IdentificationRerouteSuccess: "identification-re-route-success",
  IdentificationRerouteError: "identification-re-route-error",
  IdentificationApprove: "identification-approve",
  IdentificationRejectError: "identification-reject-error",
  ComplianceReviewPutError: "compliance-review-put-errror",
  ComplianceReviewPutSuccess: "compliance-review-put-success"
});
